import { useState } from 'react'
import { Bug } from 'lucide-react'
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@teach/ui'
import { ReportBugDialog } from './ReportBugDialog'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/**
 * Шапка редактора: жучок; с `lg` — с подписью «Нашли баг?», на телефоне — только
 * значок (место в шапке занято названием курса).
 */
export const ReportBugHeaderButton = () => {
  const m = useMessages(messages)
  const [open, setOpen] = useState(false)
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={m.foundBug}
        title={m.reportBug}
        className="flex h-8 shrink-0 items-center gap-1.5 rounded-full px-2 text-sm text-muted-foreground transition-colors hover:bg-foreground/5 hover:text-foreground lg:px-3"
      >
        <Bug className="size-4" />
        <span className="hidden whitespace-nowrap lg:inline">{m.foundBug}</span>
      </button>
      <ReportBugDialog open={open} onOpenChange={setOpen} />
    </>
  )
}

/** Сайдбар (ПК и выезжающий на телефоне): внизу слева «Сообщить о баге». */
export const ReportBugSidebarButton = () => {
  const m = useMessages(messages)
  const [open, setOpen] = useState(false)
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton onClick={() => setOpen(true)} tooltip={m.foundBug}>
          <Bug className="size-[17px]" />
          <span>{m.reportBug}</span>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <ReportBugDialog open={open} onOpenChange={setOpen} />
    </SidebarMenu>
  )
}
